import React from 'react';
import i18next from 'i18next';
import Dropdown from '../../Dropdown/Dropdown';
import InputText from '../../InputText/InputText';
import ExchangeResult from './ExchangeResult/ExchangeResult';

const MAX_AMOUNT = 10000000;

export default class CryptoCalc extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      value: 0,
      amount: 0,
      usd: 0,
    };
  }

  handleAmountChange = (event) => {
    this.setState({ value: event.target.value }, () => {
      this.calc();
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.coin !== this.props.coin) {
      this.calc();
    }
  }

  calc = () => {
    const { coin, coins } = this.props;

    const value = +this.state.value;
    const { price } = coins.find((c) => c.id === coin) || {};
    const { usdrex } = coins.find((c) => c.id === coin) || {};

    if (Number.isNaN(value) || !price || !usdrex) {
      this.setState({ amount: 0 });
      this.setState({ usd: 0 });
    } else {
      const amount = Math.max(0, Math.floor(price * value));
      const usd = Math.max(0, Math.floor(amount / usdrex));

      if (amount > MAX_AMOUNT) {
        this.setState({ value: Math.floor((MAX_AMOUNT / price) * 100) / 100 });
        this.setState({ amount: MAX_AMOUNT });
        this.setState({ usd: MAX_AMOUNT / usdrex });
      } else {
        this.setState({ amount });
        this.setState({ usd });
      }
    }
  };

  render() {
    const { coin, onChange, coins } = this.props;

    return (
      <div className="crypto-calc">
        <span className="form__title form__title--center form__title--secondary form__title--small">
          {i18next.t('crypto_calc.title')}
        </span>

        <div className="crypto-calc__form">
          <Dropdown
            placeholder={i18next.t('crypto_calc.coin_select')}
            className="crypto-calc__select"
            value={coin}
            onChange={onChange}
            options={coins.map((coin) => ({
              value: coin.id,
              label: coin.name,
            }))}
          />

          <InputText
            placeholder="Введите сумму в крипте"
            view="rectangle"
            className="crypto-calc__amount"
            onChange={this.handleAmountChange}
            value={this.state.value}
          />
        </div>

        <ExchangeResult
          className="crypto-calc__result"
          amount={this.state.amount}
          usd={this.state.usd}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Crypto/CryptoCalc/CryptoCalc.jsx